import { MezoModalProps, STAKING_LOCK_DURATION } from "#/shared/types"
import { StepperModal } from "#/ui/Modal"

import ReviewAndSignStep from "./ReviewAndSignStep"
import StakeAndLockStep from "./StakeAndLockStep"
import SuccessfullyStakedStep from "./SuccessfullyStakedStep"

export default function StakingModal(props: MezoModalProps) {
  return (
    <StepperModal
      {...props}
      initialContextValue={{
        amount: "",
        lockDuration: STAKING_LOCK_DURATION.FOUR_MONTHS,
      }}
      steps={[
        {
          title: "Stake & lock",
          withCloseButton: true,
          component: StakeAndLockStep,
        },
        {
          title: "Review and sign",
          component: ReviewAndSignStep,
        },
        {
          title: "Successfully staked",
          component: SuccessfullyStakedStep,
          withCloseButton: true,
          withBackButton: false,
        },
      ]}
    />
  )
}
